import { api } from './api';
import { UnitHistoryEvent, PriceTrendData, MarketInsights, ProjectPerformance } from '../types/unit-history';

export const unitHistoryApi = {
  getUnitHistory: (unitId: number): Promise<UnitHistoryEvent[]> =>
    api.get(`/units/${unitId}/history`).then(r => r.data),

  getPriceTrends: (projectId: number, days: number = 30): Promise<PriceTrendData[]> =>
    api.get(`/units/trends/${projectId}?days=${days}`).then(r => r.data),

  getMarketInsights: (projectId: number): Promise<MarketInsights> =>
    api.get(`/units/insights/${projectId}`).then(r => r.data),

  getProjectPerformance: (projectId: number): Promise<ProjectPerformance> =>
    api.get(`/units/performance/${projectId}`).then(r => r.data)
};
